import processMap from '../../images/DevelopmentMap.svg';
const Development = () =>{
    return(
        <>
            <section>
            <h2 className="uppercase font-medium w-full
                xl:text-4xl xl:pb-12
                lg:text-4xl lg:pb-12
                md:text-3xl md:pb-10
                sm:text-[28px] sm:pb-4 ">Развитие продукта</h2>
                <img src={processMap} alt="development map"/>
            </section>
        </>
    )
}

export default Development;